// extracted by mini-css-extract-plugin
var _1 = "RequestEditStatusModal-moduleconfirmationModal__n8PZD Modal-moduleModal__c1dw1";
export { _1 as "confirmationModal" }
